import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import { BrowserRouter as Router } from 'react-router';
import { AppRoutes } from '@app/routing/routes';
import '@app/app.css';


const App: React.FunctionComponent = () => {

  return (
    <Router>
        <React.Suspense fallback={<div>Loading...</div>}>
          <AppRoutes />
        </React.Suspense>
    </Router>
  );
};

export default App;

